import script from "./CustomizerMiniRadioSwatch.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomizerMiniRadioSwatch.vue?vue&type=script&lang=ts&setup=true"

import "./CustomizerMiniRadioSwatch.vue?vue&type=style&index=0&id=63110d1b&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63110d1b"]])

export default __exports__